module.exports = __webpack_public_path__ + "img/chevron-down.e82a2cdc.svg";